import { FC } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Button } from '@frontend/design-system';
import { useChatbotAssistant } from '../../provider/chatbot-assistant.provider';
import { getWeaveCopilotTrackingId, WEAVE_COPILOT_ACTIONS } from '../../tracking-ids';

interface SendActionProps {
  disabled?: boolean;
  onClick?: () => void;
}
export const SendAction: FC<SendActionProps> = ({ disabled, onClick }) => {
  const { t } = useTranslation('aiOnboarding');
  const { isSending, source } = useChatbotAssistant();

  return (
    <Button
      onClick={isSending ? undefined : onClick}
      disabled={disabled}
      aria-label={t('Send')}
      css={styles.button}
      trackingId={getWeaveCopilotTrackingId({ source, action: WEAVE_COPILOT_ACTIONS.sendButton })}
    >
      <Icon name='up' color='white' size={16} />
    </Button>
  );
};

const styles = {
  button: css`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.colors.neutral70};
    border-radius: ${theme.borderRadius.full};
    width: 28px;
    height: 28px;
    &[aria-disabled='true'],
    &:disabled {
      background-color: ${theme.colors.neutral20};
      cursor: not-allowed;
    }
  `,
};
